import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    permissions: [],
    userPermissions: []
  },
  mutations: {
    setPermissions (state, permissions) {
      state.permissions = permissions
    },
    setUserPermissions (state, permissions) {
      state.userPermissions = permissions
    }
  },
  actions: {
  },
  modules: {
  },
  getters: {
    access: (state) => (name) => {
      if (!state.permissions.includes(name)) {
        return true
      } else if (state.userPermissions.includes(name)) {
        return true
      } else {
        return false
      }
    }
  }
})
export default store
